"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCEPTED_SIGNATURE_TYPES = exports.MAX_SIGNATURE_SIZE = exports.signatureUrlSchema = exports.avatarFileSchema = exports.MAX_AVATAR_SIZE = exports.pictureSchema = void 0;
exports.isAcceptedSignatureType = isAcceptedSignatureType;
const zod_1 = require("zod");
exports.pictureSchema = zod_1.z.string().nullable().optional().default('');
exports.MAX_AVATAR_SIZE = 10000000;
const ACCEPTED_IMAGE_TYPES = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/webp',
];
exports.avatarFileSchema = zod_1.z
    .any()
    .optional()
    .refine((file) => {
    if (!file) {
        return true;
    }
    return ACCEPTED_IMAGE_TYPES.includes(file.type);
}, 'form.errors.avatar-file-type')
    .refine((file) => {
    if (!file) {
        return true;
    }
    return file.size <= exports.MAX_AVATAR_SIZE;
}, 'form.errors.avatar-max-size');
// Signature
exports.signatureUrlSchema = zod_1.z
    .string()
    .nullable()
    .optional()
    .default(null);
/**
 * Max size of a stored signature image (2 MB). A drawn signature is a PNG of a
 * few KB; the margin is for the scans admins still upload for attendings.
 */
exports.MAX_SIGNATURE_SIZE = 2 * 1024 * 1024;
/** MIME types accepted for a signature image. Declared type is trusted. */
exports.ACCEPTED_SIGNATURE_TYPES = [
    'image/png',
    'image/jpeg',
];
/**
 * Whether an uploaded file's declared MIME type is accepted for a signature.
 *
 * @param mimetype - Declared MIME type of the upload.
 * @returns `true` for PNG and JPEG only.
 */
function isAcceptedSignatureType(mimetype) {
    return exports.ACCEPTED_SIGNATURE_TYPES.includes(mimetype);
}
